var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "renderer phone-simple-renderer" },
    [
      _vm.phoneName != ""
        ? _c("router-link", { attrs: { to: _vm.link } }, [
            _c("span", [_vm._v(_vm._s(_vm.phoneName))]),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }